module.exports = new __parcel__URL__("video.7c47708e.svg").toString();